<script>
import apiConnector from '@/epersonam/apiConnector';
import spinner from '../spinner';

export default {
  name: 'phoneVerification',
  template: '#phone-verification-vue',
  components: {
    spinner,
  },
  data() {
    return {
      isLoading: false,
      state: 'verify-number', // verify-number | verify-code
      verification_via: 'sms', // sms | call
      userPhone: {
        country_code: null, // default is given by html
        phone_number: null,
      },
      verification_code: null,
      error: null,
    };
  },
  methods: {
    submitPhoneVerification() {
      this.startRequest();
      this.userPhone.country_code = `+${$('.countries-input')
        .val()
        .replace(/[^0-9]/g, '')}`;
      apiConnector()
        .post(`/${window.locale}/phone_verifications`, {
          verification: {
            ...this.userPhone,
            via: this.verification_via,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.isLoading = false;
            // this.ss = this.data.message
            this.state = 'verify-code';
          } else {
            this.showError(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.showError('gen-error');
        });
    },
    submitChallengeVerification() {
      this.startRequest();
      apiConnector()
        .post(`/${window.locale}/phone_verifications/verify`, {
          verification: {
            ...this.userPhone,
            verification_code: this.verification_code,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.isLoading = false;
            // this.ss = this.data.message
            this.state = 'verify-code';
          } else {
            this.showError(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.showError('gen-error');
        });
    },
    startRequest() {
      this.isLoading = false;
      this.error = null;
    },
    showError(err) {
      this.isLoading = false;
      this.error = err;
    },
  },
};
</script>
